import React from 'react'
import { useNavigate } from 'react-router-dom'
import { Box, Button, Paper, Typography } from '@mui/material'
import { CalendarIcon } from '@mui/x-date-pickers'
import { format } from 'date-fns'

import { ProcessProgress } from '~pages/CasesScreen/components/ProcessDetails'
import { Case2, ProcessSummary } from '~types'

export type Case2WithProcess = Case2 & { processSummary: ProcessSummary | null }

interface CaseWithProcessProps {
  case: Case2WithProcess
  showTitle?: boolean
}

export const CaseWithProcess: React.FC<CaseWithProcessProps> = ({
  case: caseData,
  showTitle = false,
}) => {
  const navigate = useNavigate()

  return (
    <Paper
      sx={{
        border: 1,
        borderColor: 'grey.400',
        borderRadius: '10px',
        p: 2,
        pr: 4,
        mb: 2,
        boxShadow: '0px 2px 4px rgba(0, 0, 0, 0.1)',
      }}
      elevation={2}
    >
      {showTitle && (
        <Typography variant='body1' sx={{ mb: 1, fontWeight: 'bold' }}>
          {caseData.title}
        </Typography>
      )}
      {caseData.processSummary && (
        <ProcessProgress
          completedSteps={caseData.processSummary.completed_steps}
          totalSteps={caseData.processSummary.total_steps}
          currentStepName={caseData.processSummary.current_step_name || ''}
          showStepCount={false}
          big={true}
        />
      )}
      <Box display='flex' alignItems='center' gap={1} mt={1}>
        <CalendarIcon />
        <Typography variant='body2'>
          Created: {format(new Date(caseData.created_time), 'MMM dd, yyyy')}
        </Typography>
      </Box>
      <Button
        variant='contained'
        color='secondary'
        onClick={() => navigate(`/cases/${caseData.handle}/apply`)}
        sx={{ mt: 1 }}
      >
        Go To Case
      </Button>
    </Paper>
  )
}
